export function execJsByPage() {
  const page = $("[data-page]").data("page");

  switch (page) {
    case "site-home":
      siteHome();
      break;
    case "site-seminovos-detalhe":
      siteSeminovosDetalhe();
      break;
    case "site-ofertas":
      siteOfertas();
      break;
    case "site-page":
      sitePage();
      break;
    default:
      break;
  }

  function siteHome() {
    $.request('onGetFeaturedVehicles', {
      data: { limit: 4 },
      complete: function() {
        initSwiperUsedCarsHighlights();
      }
    });

    function initSwiperUsedCarsHighlights(){
      const swiperUsedHighlights = new Swiper('.swiper-used-cars-highlights', {
        slidesPerView: 1,
        spaceBetween: 30,
        watchOverflow: true,
        observer: true,
        centerInsufficientSlides: true,
        navigation: {
          nextEl: '.swiper-button-next.used-cars-highlights',
          prevEl: '.swiper-button-prev.used-cars-highlights',
        },
        pagination: {
          el: '.swiper-pagination.used-cars-highlights',
          clickable: true,
        },
        breakpoints: {
          1200: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1600: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
      });
    }
  }

  function siteSeminovosDetalhe() {
    const carRequestedId = $("#carId").val();

    $.request('onGetRelated', {
      data: { carRequestedId },
      complete: function() {
        showRelatedCars();
      }
    });

    function showRelatedCars() {
      const seminovosRelatedSection = document.getElementById('seminovosRelatedSection');
      seminovosRelatedSection.classList.add('show-relateds');

      const swiperUsedModelInternalRelated = new Swiper('.used-model-internal-related-slider', {
        clickable: true,
        slidesPerView: 1,
        spaceBetween: 15,
        watchOverflow: true,
        observer:true,
        observeParents: true,
        observeSlideChildren: true,
        watchOverflow :true,
        pagination: {
          el: '.swiper-pagination.related',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next.related',
          prevEl: '.swiper-button-prev.related',
        },
        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          1500: {
            slidesPerView: 4,
            spaceBetween: 15,
          }
        }
      });
    }
  }

  function siteOfertas() {
    let currentOrder = 'desc';
    let pageNum = 1;
    let limit = 9;

    function loadPromotions(order, page) {
        $('#promotions').css('filter', 'blur(10px)');

        $.request('onGetPromotions', {
            data: {
                order: order,
                page: page,
                limit: limit
            },
            success: function (res) {
                $('#promotions').html(res['#promotions']);
                $('#pagination').html(res['#pagination']);
            },
            error: function (err) {
                console.error('Erro ao carregar promoções:', err);
            },
            complete: function () {
                $('#promotions').css('-filter', 'none');
            }
        });
    }

    loadPromotions(currentOrder, pageNum);

    $(document).on('click', '.pagination .page-link', function (e) {
        e.preventDefault();
        const selectedPage = parseInt($(this).data('page'));
        if (!isNaN(selectedPage)) {
            pageNum = selectedPage;
            loadPromotions(currentOrder, pageNum);
        }
    });
  }

  function sitePage() {
    $(".form-main").addClass("d-none");
  }
}